(function () {
  const POPUP_ID = 'ExitIntentPopup';
  const DISMISS_KEY = 'exitIntentPopupDismissed';
  const MOBILE_DELAY = 30000;

  const justSubscribed = /(?:^|[?&])customer_posted=true(?:&|$)/.test(window.location.search);

  if (justSubscribed) {
    const cleanUrl = window.location.pathname + window.location.search.replace(/[?&]customer_posted=true/, '').replace(/^&/, '?');
    window.history.replaceState(null, '', cleanUrl.replace(/\?$/, ''));
    window.scrollTo(0, 0);
    window.requestAnimationFrame(function () {
      window.scrollTo(0, 0);
    });
  }

  function init() {
    const popup = document.getElementById(POPUP_ID);
    if (!popup) return;

    const formState = popup.querySelector('[data-exit-intent-state="form"]');
    const successState = popup.querySelector('[data-exit-intent-state="success"]');
    const copyButton = popup.querySelector('[data-exit-intent-copy]');
    const closeTriggers = popup.querySelectorAll('[data-exit-intent-close]');

    let shown = false;

    function openPopup() {
      if (shown) return;
      shown = true;
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closePopup() {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      sessionStorage.setItem(DISMISS_KEY, '1');
    }

    closeTriggers.forEach(function (el) {
      el.addEventListener('click', closePopup);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
    });

    if (copyButton) {
      copyButton.addEventListener('click', function () {
        const codeEl = copyButton.previousElementSibling;
        const code = codeEl ? codeEl.textContent.trim() : 'WELCOME10';
        const label = copyButton.dataset.copyLabel || copyButton.textContent;
        const successLabel = copyButton.dataset.copySuccess || label;
        navigator.clipboard.writeText(code).then(function () {
          copyButton.textContent = successLabel;
          setTimeout(function () {
            copyButton.textContent = label;
          }, 2000);
        });
      });
    }

    if (justSubscribed) {
      if (formState) formState.hidden = true;
      if (successState) successState.hidden = false;
      sessionStorage.setItem(DISMISS_KEY, '1');
      openPopup();
      return;
    }

    if (sessionStorage.getItem(DISMISS_KEY)) return;

    const mobileQuery = window.matchMedia('(max-width: 749px)');

    if (mobileQuery.matches) {
      setTimeout(openPopup, MOBILE_DELAY);
    } else {
      document.addEventListener('mouseout', function (event) {
        if (!event.relatedTarget && event.clientY <= 0) {
          openPopup();
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
